export default __webpack_public_path__ + "static/media/a1.4c4e38e9.webp";